// LiveStreamUserAvatar.js
import { connect } from 'react-redux';

import { LIVESTREAM_AVATAR_QUEUE_DELAY_MSEC } from '../RemoteConfigKeys.js';

import fetchUser from '../action/fetchUser.js';
import getMeData from '../selector/getMeData.js';
import getUserData from '../selector/getUserData.js';
import getRankInLiveStream from '../selector/getRankInLiveStream.js';
import getListData from '../selector/getListData.js';
import getGoalData from '../selector/getGoalData.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

import LiveStreamUserAvatar from '../component/LiveStreamUserAvatar.jsx';

const mapStateToProps = (
  state,
  { streamId, userId, range, category, shouldDisplayMVP = true }
) => {
  const meId = getMeData(state, 'id');
  const fundingId = getLiveStreamData(
    state,
    [streamId, 'privateShow'],
    'fundingId'
  );
  const color = userId
    ? userId === meId
      ? getMeData(state, 'avatarColor')
      : getUserData(state, userId, 'avatarColor')
    : null;
  const username = userId
    ? userId === meId
      ? getMeData(state, 'username')
      : getUserData(state, userId, 'username')
    : null;
  const sessionId = getLiveStreamData(state, [streamId], 'sessionId');
  const rank = userId
    ? getRankInLiveStream(state, streamId, sessionId, userId, range, category)
    : null;
  const mvpUserId = getListData(
    state,
    ['goal', fundingId, 'breakdown'],
    'itemIds'
  )?.[0];
  const mvpUserData = getGoalData(state, [fundingId, 'breakdown'], mvpUserId);
  const isMVP = shouldDisplayMVP ? userId === mvpUserData?.id : false;
  const hasSenderAvatarId = getUserData(state, userId, 'hasSenderAvatarId');
  return {
    meId,
    username,
    color,
    rank,
    isMVP,
    hasSenderAvatarId,
    queueDelayMsec: getRemoteConfigData(
      state,
      LIVESTREAM_AVATAR_QUEUE_DELAY_MSEC
    ),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchUser: ({ userId }) => dispatch(fetchUser({ id: userId })),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LiveStreamUserAvatar);
